// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__dKA5f","colCheckbox":"styles_colCheckbox__foCHd"};